/* Product info tabs — the tab strip at the foot of the stacked PDP layouts.

   The panels are rendered with `hidden` on all but the selected one, so the
   section is already in its resting state before this file runs and there is no
   flash of four stacked panels on a slow connection. Everything here is state
   changes on top of that. */
(function () {
  'use strict';

  /* The section loads this file itself, so a section reload in the theme editor
     re-runs the whole IIFE. Bailing out on the second pass leaves the first
     copy in charge — its shopify:section:load handler picks up the new markup,
     and nothing ends up with two sets of listeners. */
  if (window.__fiInfoTabsLoaded) return;
  window.__fiInfoTabsLoaded = true;

  var GROUPS = new WeakMap();

  function select(root, tab, moveFocus) {
    var tabs = GROUPS.get(root);
    if (!tabs || tabs.indexOf(tab) === -1) return;

    tabs.forEach(function (candidate) {
      var selected = candidate === tab;
      var panel = document.getElementById(candidate.getAttribute('aria-controls'));
      candidate.setAttribute('aria-selected', selected ? 'true' : 'false');
      /* Only the selected tab stays in the tab order — arrow keys move between
         them once you are inside the strip, which is what a tablist owes a
         keyboard user. */
      candidate.setAttribute('tabindex', selected ? '0' : '-1');
      if (panel) panel.hidden = !selected;
    });

    /* The strip scrolls sideways on a phone, so a tab reached by keyboard or by
       the sticky header can be sitting off-screen. */
    if (tab.scrollIntoView) {
      tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    if (moveFocus) tab.focus();
  }

  function findByLabel(root, label) {
    var wanted = String(label || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    if (!wanted) return null;
    var tabs = GROUPS.get(root) || [];
    for (var i = 0; i < tabs.length; i += 1) {
      var text = (tabs[i].getAttribute('data-label') || tabs[i].textContent)
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
      if (text === wanted) return tabs[i];
    }
    return null;
  }

  function init(root) {
    if (!root || GROUPS.has(root)) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-fi-itab]'));
    if (!tabs.length) return;
    GROUPS.set(root, tabs);

    root.addEventListener('click', function (event) {
      var tab = event.target.closest ? event.target.closest('[data-fi-itab]') : null;
      if (!tab || !root.contains(tab)) return;
      select(root, tab, false);
    });

    root.addEventListener('keydown', function (event) {
      var tab = event.target.closest ? event.target.closest('[data-fi-itab]') : null;
      if (!tab) return;
      var index = tabs.indexOf(tab);
      var next = null;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = tabs[(index + 1) % tabs.length];
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = tabs[(index - 1 + tabs.length) % tabs.length];
      else if (event.key === 'Home') next = tabs[0];
      else if (event.key === 'End') next = tabs[tabs.length - 1];

      if (!next) return;
      event.preventDefault();
      select(root, next, true);
    });
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-fi-itabs]');
    Array.prototype.forEach.call(roots, init);
  }

  /* The sticky product header names the row it wants open by its heading text —
     the attribute is older than this section and still says "accordion". Its own
     handler in fi-pdp-v5.js scrolls to the section; opening the right tab once we
     have arrived is this file's half of the job. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('[data-fi-tab][data-fi-open-accordion]') : null;
    if (!link) return;
    var wanted = link.getAttribute('data-fi-open-accordion');
    var roots = document.querySelectorAll('[data-fi-itabs]');
    Array.prototype.forEach.call(roots, function (root) {
      var tab = findByLabel(root, wanted);
      if (tab) select(root, tab, false);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  /* Editing a tab in the theme editor should show that tab. */
  document.addEventListener('shopify:block:select', function (event) {
    var tab = event.target.querySelector
      ? event.target.querySelector('[data-fi-itab]') || event.target.closest('[data-fi-itab]')
      : null;
    if (!tab) return;
    var root = tab.closest('[data-fi-itabs]');
    if (root) {
      init(root);
      select(root, tab, false);
    }
  });
})();
